import { Box } from '@mui/material';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@design-system/collapsible';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { ExpandMore } from '@mui/icons-material';
import { useEWallet } from '../services/get-e-wallet';

const EWalletCollapse = () => {
  const [open, setOpen] = useState(true);
  const { data: eWalletData } = useEWallet();
  const eWallet = eWalletData?.results?.[0];

  return (
    <Box
      className='w-full border border-primary-200 rounded-lg py-3 px-3 mt-4'
      sx={{ bgcolor: '#fdfdfe' }}
    >
      <Collapsible
        open={open}
        onOpenChange={setOpen}
      >
        <CollapsibleTrigger asChild>
          <button className='flex items-center justify-between w-full text-lg font-semibold'>
            <p className='text-gray-800 text-lg font-medium flex items-center gap-1'>
              E-Wallet
            </p>
            <motion.div
              animate={{ rotate: open ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <ExpandMore className='w-6 h-6' />
            </motion.div>
          </button>
        </CollapsibleTrigger>

        <CollapsibleContent className='overflow-hidden mt-4'>
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: open ? 1 : 0, height: open ? 'auto' : 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className='text-gray-600 text-sm mb-1'>Wallet</p>
            <p className='text-gray-800 font-medium text-sm mb-3 capitalize'>
              {eWallet?.provider_name?.replace('_', ' ').toLocaleLowerCase() ||
                '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Recipient Name</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {eWallet?.recipient_name || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Recipient Number</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {eWallet?.recipient_number || '-'}
            </p>
          </motion.div>
        </CollapsibleContent>
      </Collapsible>
    </Box>
  );
};

export default EWalletCollapse;
